module.exports = __webpack_public_path__ + "static/scale-model-of-golden-gate-bridge-view-in-san-francisco-california-1e35658dd6ca9d25e051e4327fc85637.png";